import type { DashboardStats, Stats } from '@geartracker/types';

import axios, { endpoints } from 'src/utils/axios';

import { useQuery } from '@tanstack/react-query';

export const statsKeys = {
  all: ['stats'] as const,
  dashboard: ['stats', 'dashboard'] as const,
};

export const useStats = (enabled = true) => {
  return useQuery({
    queryKey: statsKeys.all,
    queryFn: async (): Promise<Stats> => {
      const response = await axios.get(endpoints.stats.root);
      return response.data;
    },
    enabled,
  });
};

export const useDashboardStats = (enabled = true) => {
  return useQuery({
    queryKey: statsKeys.dashboard,
    queryFn: async (): Promise<DashboardStats> => {
      const response = await axios.get(endpoints.stats.dashboard);
      return response.data;
    },
    enabled,
  });
};
